// extracted by mini-css-extract-plugin
module.exports = {"footer":"DocFooter_footer__vsmFa","text":"DocFooter_text__n9lP2"};